
export class formTypeFile {
	constructor(content) {
		this.content = content;
		this.input = this.content.querySelector('input');
		this.text = this.content.querySelector('.text');

		this.input.addEventListener('change', (e) => {
			// console.log(e.target.files[0].name);
			this.text.innerHTML = e.target.files[0].name;
		});
	}
}
export class formTypeSelect {
	constructor(content) {
		this.content = content;
		this.button = this.content.querySelector('.type-select__button');
		this.startValue = this.button.innerHTML;
		this.list = this.content.querySelectorAll('.type-select__list');
		this.inputs = this.content.querySelectorAll('.type-select__list input[type=radio]');
		// init
		this.close();
		this.controllers();
	}

	controllers() {
		this.button.onclick = (e) => {
			if(!e.target.classList.contains('open')){
				e.target.classList.add("open")
				this.open();
			}
			else{
				this.button.classList.remove('open');
				this.close();
			}
		};

		this.inputs.forEach((inputRadio) => {
			inputRadio.onclick = (e) => {
				this.button.innerHTML = e.target.value === 'on' ? this.startValue : e.target.parentNode.innerText;
				this.button.classList.remove('open');
				this.close();
			};
		});
	}
	open() {
		if(this.list){
			this.list.forEach( list => {
				list.classList.add('open');
			})
		}
		this.content.style.zIndex = '101';
	}

	close() {
		this.content.style.zIndex = '99';
		if(this.list){
			this.list.forEach( (list) => {
				list.classList.remove('open');
			})
		}
	}
}

/**
 * CHAMP DU TYPE MASTER / SLAVE
 */
export class formTypeSelectMasterSlave{
	constructor(content){
		this.content = content;
		// master
		this.master = content.querySelector('.type-select-master');
		this.buttonMaster = this.master.querySelector('.type-select__button');
		this.listMaster = this.master.querySelectorAll('.type-select__list');
		this.inputsMaster = this.master.querySelectorAll('.type-select__list input[type=radio]');
		this.startValueMaster = this.buttonMaster.innerHTML;

		// slave
		this.slave = content.querySelector('.type-select-slave');
		this.buttonSlave = this.slave.querySelector('.type-select__button');
		this.listSlave = this.slave.querySelectorAll('.type-select__list');
		this.inputsSlave = this.slave.querySelectorAll('.type-select__list input[type=radio]');
		this.startValueSlave = this.buttonSlave.innerHTML;
		this.stateSlave = false;

		this.controllers();
		this.disableSlave();
	}

	controllers() {
		// Master
		this.buttonMaster.onclick = (e) => {
			if(!this.buttonMaster.classList.contains('open')){
				this.openMaster();
				this.stateSlave = true;
				this.buttonSlave.classList.remove('disable');
				this.closeSlave();
			}
			else{
				this.filterSlave(this.branchSelect)
				this.closeMaster();
			}
		}
		

		this.inputsMaster.forEach((inputRadio) => {
			inputRadio.onclick = (e) => {
				this.buttonMaster.innerHTML = e.target.value === 'on' ? this.startValueMaster : e.target.parentNode.innerText;
				this.branchSelect = e.target.value === 'on' ? undefined : e.target.value;
				this.filterSlave(this.branchSelect)
				this.closeMaster();
			};
		});

		// SLAVE
		this.buttonSlave.onclick = (e) => {
			if(this.stateSlave){
				if(!this.buttonSlave.classList.contains('open')){
					this.openSlave();
				}
				else{
					this.closeSlave();
				}
			}
		}

		this.listSlave.forEach( list =>{
			list.querySelectorAll('.type-select__list input[type=radio]').forEach( (inputRadio) => {
				inputRadio.onclick = (e) => {
					this.buttonSlave.innerHTML = e.target.value === 'on' ? this.startValueSlave : e.target.parentNode.innerText;
					this.closeSlave();
				};
			});
		} )
	}

	filterSlave(value){
		this.listSlave.forEach( (list) =>{
			if(list.dataset.branch === value){
				if( !list.querySelector("li") ) this.disableSlave();
			}

			list.dataset.branch != value ? list.style.display = "none" : list.style.display = "";
			// REBOOT À LA PREMIÈRE VALEUR;
			// RESET LES CHECKS
			list.querySelectorAll('.type-select__list input[type=radio]').forEach( item => {
					item.checked = false
			})
			this.buttonSlave.innerHTML = this.startValueSlave;
		})
	}
	disableSlave(){
		this.stateSlave = false;
		this.buttonSlave.classList.add('disable');
	}

	openMaster() {
		this.listMaster.forEach( list => {
			list.classList.add('open');
		})
		this.buttonMaster.classList.add('open')
	}
	
	openSlave(){
		this.listSlave.forEach( list => {
			list.classList.add('open');
		})
		this.buttonSlave.classList.add('open')
	}
	
	closeMaster() {
		this.listMaster.forEach( (list) => {
			list.classList.remove('open');
		})
		this.buttonMaster.classList.remove('open')
	}
	
	closeSlave() {
		this.listSlave.forEach( (list) => {
			list.classList.remove('open');
		})
		this.buttonSlave.classList.remove('open')
	}

}
